import { Modal } from "@wordpress/components";
import { useState } from "@wordpress/element";
import { AppHeader } from "./components/AppHeader";
import ImageGrid from "./components/ImageGrid";
import ProvidersAndFilters from "./components/ProvidersAndFilters";
import { __ } from '@wordpress/i18n'
const App = () => {
	const [modalImageUrl, setModalImageUrl] = useState(null);

	const closeModal = () => {
		setModalImageUrl(null);
	};

	return (
		<div className="image-hub-app-container">
			<AppHeader enableBrowseButton={false} enableSettingsButton={true} />

			<ProvidersAndFilters />
			<ImageGrid setModalImageUrl={setModalImageUrl} />
			{!!modalImageUrl && (
				<Modal
					className="image-hub-modal"
					title={__('View full image', 'image-hub')}
					onRequestClose={closeModal}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							width: "100%",
							height: "100%",
						}}
					>
						<img
							style={{
								objectFit: "contain",
								height: "100%",
								width: "100%",
							}}
							src={modalImageUrl}
							alt="Full size"
						/>
						<a
							href={modalImageUrl}
							style={{ width: "fit-content" }}
							target="_blank"
						>
							{__('Open image in new tab', 'image-hub')}
						</a>
					</div>
				</Modal>
			)}
		</div>
	);
};

export default App;
